import { render, staticRenderFns } from "./OrganizationUsersItem.vue?vue&type=template&id=0a628a1d&"
import script from "./OrganizationUsersItem.vue?vue&type=script&lang=ts&"
export * from "./OrganizationUsersItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports